import { cloneDeep } from 'lodash';
import React from 'react';
import { IVectorEffect } from '@/version-types';
import { hasReflection, hasShadow } from './utils';

interface IShapeProps extends React.SVGProps<SVGRectElement | SVGEllipseElement> {
    id: string;
    naturalHeight: number;
    naturalWidth: number;
    effect?: IVectorEffect;
    tag: React.ElementType;
    blur?: number;
}
const BaseSvg: React.FC<IShapeProps> = (props) => {
    const { id, effect, naturalHeight, naturalWidth, blur, tag: Tag, ...resetProps } = props;

    if (blur) {
        resetProps.filter = `url(#blur-filter_${id})`;
    }
    const Shadow = () => {
        if (!effect || !hasShadow(effect)) return null;
        const shadow = effect.shadow[0];
        const shadowProps = cloneDeep(resetProps);
        delete shadowProps.filter;
        if (shadow.blur) shadowProps.filter = `url(#shadow-filter_${id})`;

        const { color, x, y, opacity } = shadow;

        //去除border
        if (Tag === 'rect') {
            shadowProps.width = Math.max(naturalWidth, 1);
            shadowProps.height = Math.max(naturalHeight, 1);
            shadowProps.x = 0;
            shadowProps.y = 0;
        } else if (Tag === 'ellipse') {
            shadowProps.rx = Math.max(naturalWidth / 2, 1);
            shadowProps.ry = Math.max(naturalHeight / 2, 1);
        }

        shadowProps.style = {
            // ...resetProps.style,
            fill: color,
            transform: `translate(${x}px,${y}px)`,
            opacity,
        };
        return <Tag {...shadowProps}></Tag>;
    };

    const Reflection = () => {
        if (!effect || !hasReflection(effect)) return null;
        const reflection = effect.reflection[0];
        const reflectionWrapProps: React.SVGProps<SVGGElement> = {};
        const { y, opacity } = reflection;
        const _resetProps = cloneDeep(resetProps);
        delete _resetProps.filter;
        if (reflection.blur) {
            _resetProps.filter = `url(#reflection-filter_${id})`;
        }

        reflectionWrapProps.style = Object.assign({}, reflectionWrapProps.style, {
            transform: `translateY(${2 * naturalHeight + y}px) scale(1,-1)`,
            opacity,
        });

        reflectionWrapProps.mask = `url(#mask_${id})`;
        return (
            <g {...reflectionWrapProps}>
                <Tag {..._resetProps}></Tag>
            </g>
        );
    };

    return (
        <React.Fragment>
            {Reflection()}
            {Shadow()}
            <Tag {...resetProps}></Tag>
        </React.Fragment>
    );
};
export default BaseSvg;
